// Centralised constants — import from here instead of duplicating in Navbar, Footer, Products, etc.

export const SITE_URL = 'https://www.galaxywaterproofing.com';
export const OG_IMAGE  = `${SITE_URL}/GalaxyTitleLogo.webp`;

export const PRODUCT_LINKS = {
  'Cormix H2O Stop':  '/tds/cormix-h2o-stop.pdf',
  'Contite Seal ACCI': '/tds/contite-seal-acci.pdf',
  'Conplug F':         '/tds/conplug.pdf',
  'Contite G600':      '/tds/contite-g600.pdf',
};

export const CONTACT_PHONE = '+971507352571';
export const CONTACT_PHONE_DISPLAY = '+971 50 735 2571';
export const CONTACT_EMAIL = 'akul@galaxysp.net';
export const CONTACT_ADDRESS = 'Office No. 604, D2 Tower, Al Barsha 1, Behind Mall of the Emirates, Dubai';
